export default __webpack_public_path__ + "static/media/tree10.f519af79.png";